// LogParsingInput.js
import React, { useState } from 'react';

function LogParsingInput({ onUpdate }) {
  const [inputValues, setInputValues] = useState(['']);

  const handleChange = (index, value) => {
    const newInputValues = [...inputValues];
    newInputValues[index] = value;
    setInputValues(newInputValues);
  };

  const handleAddInput = () => {
    setInputValues([...inputValues, '']);
  };

  const handleRemoveInput = (index) => {
    const newInputValues = [...inputValues];
    newInputValues.splice(index, 1);
    setInputValues(newInputValues);
  };

  const handleUpdate = () => {
    const validKeywords = inputValues.filter(value => value.trim() !== '');
    console.log('Updating keywords:', validKeywords); // Debug: Check what we're updating
    onUpdate(validKeywords);
    setInputValues(['']); // Reset the input field after update
};

  return (
    <div>
      {inputValues.map((value, index) => (
        <div key={index}>
          <input
            type="text"
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            placeholder="Enter string to parse"
          />
          {index === inputValues.length - 1 && (
            <button onClick={handleAddInput}>+</button>
          )}
          {index > 0 && (
            <button onClick={() => handleRemoveInput(index)}>-</button>
          )}
        </div>
      ))}
      <button onClick={handleUpdate}>Update</button>
    </div>
  );
}

export default LogParsingInput;
